import { createTheme } from '@mui/material';
import { blue } from '@mui/material/colors';

export const theme = createTheme({
    typography: {
        fontFamily: 'Play',
    },
    palette: {
        primary: {
            main: blue[700],
        },
    },
});
